<template>
	<div>
		<div id="dao">
			<div class="dhi" @click="handleSelect(1)"><img src="../assets/image/snail_logo.png"
					style="width:70%;height: 80%;"></div>
			<div class="dh" @click="handleSelect(1)" style="margin-left: 43rem;">首页</div>
			<div class="dh" @click="handleSelect(2)">产品</div>
			<div class="dh" @click="handleSelect(3)">技术与应用</div>
			<div class="dh" @click="handleSelect(4)">关于我们</div>
			<div class="dh" @click="handleSelect(5)">联系我们</div>
		</div>
		<First id="first" msg="1" />
		<Second id="second" msg="2" style="display: none;" />
		<Third id="third" msg="3" style="display: none;" />
		<Fourth id="fourth" msg="4" style="display: none;" />
		 <Fifth id="fifth" msg="5" style="display: none;"/>
		<el-backtop></el-backtop>
	</div>

</template>
<script>
	import First from '@/components/First.vue'
	import Second from '@/components/Second.vue'
	import Third from '@/components/Third.vue'
	import Fourth from '@/components/Fourth.vue'
	import Fifth from '@/components/Fifth.vue'
	export default {
		name: 'HomeView',
		components: {
			First,
			Second,
			Third,
			Fourth,
			Fifth
		},
		data() {
			return {};
		},
		methods: {
			handleSelect(key) {
				if(key==1){
				          first.style.display="block";
				          second.style.display="none";
				          third.style.display="none";
				          fourth.style.display="none";
						  fifth.style.display="none";
				        }else if(key==2){
				          first.style.display="none";
				          second.style.display="block";
				          third.style.display="none";
				          fourth.style.display="none";
						  fifth.style.display="none";
				        }else if(key==3){
				          first.style.display="none";
				          second.style.display="none";
				          third.style.display="block";
				          fourth.style.display="none";
					      fifth.style.display="none";
				        }else if(key==4){
				          first.style.display="none";
				          second.style.display="none";
				          third.style.display="none";
				          fourth.style.display="block";
						  fifth.style.display="none";
				        }else if(key==5){
				          first.style.display="none";
				          second.style.display="none";
				          third.style.display="none";
				          fourth.style.display="none";
						   fifth.style.display="block";
				        }
			}
		},

	}
</script>
<style>
	#dao {
		width: 100%;
		height: 4.5rem;
		color: white;
		background-color: black;
	}

	#dao:hover {
		color: black;
		background-color: white;
	}

	.dhi {
		margin-left: 12rem;
		width: 15rem;
		height: 3.8rem;
		padding-top: 1rem;
		float: left;
		cursor: pointer;
	}

	.dh {
		width: 9rem;
		height: 4.3rem;
		line-height: 4.5rem;
		float: left;
		cursor: pointer;
	}

	.dh:hover {
		border-bottom: solid rgb(117, 58, 68);
	}
</style>